<div class="cnae-form-control-text">
    <label class="col-form-label">
        {{label}}
    </label>
    <div class="input-group">                        
        <div class="input-group-prepend">
            <span class="input-group-text">
                {{cnae?.codigo}}
            </span>
        </div>
        <div class="input-group-values">
            <span class="input-group-main-value">
                {{cnae?.apelido ? cnae?.apelido : cnae?.nome}}
            </span>
            <span class="input-group-secondary-value" *ngIf="cnae?.apelido">
                {{cnae?.nome}}
            </span>
        </div>
    </div>
    <p class="form-text text-muted">
        {{helpText}}
    </p>
</div>